import { render, staticRenderFns } from "./SettingAuthority.vue?vue&type=template&id=7d3e9d7a&scoped=true&"
import script from "./SettingAuthority.vue?vue&type=script&lang=js&"
export * from "./SettingAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3e9d7a",
  null
  
)

export default component.exports